var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"viewDiv"}},[_c('q-spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],attrs:{"id":"loading","color":"grey-8","size":"3em","thickness":10}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }